import { ShowButton } from "@/components/refine-ui/buttons/show";
import { makeTooltip } from "@/components/ui/tooltip";
import { parseUnixTimestamp } from "@/lib/dateUtils";
import { IProviderData } from "@/types/provider";
import { ColumnDef } from "@tanstack/react-table";
import React from "react";

export const useProvidersColumns = () => {
  const columns = React.useMemo<ColumnDef<IProviderData>[]>(
    () => [
      {
        id: "id",
        accessorKey: "document.id",
        header: "ID",
      },
      {
        id: "provider",
        // accessorKey: "document.name",
        accessorFn: (row) => ({
          html:
            row.highlights.filter((h: any) => h.field === "provider")[0]
              ?.snippet ?? row.document.provider,
          logo: row.document.logo,
        }),
        header: "Name",
        minSize: 200,
        cell: function render({ getValue }: any) {
          return makeTooltip(
            <div className="flex flex-row space-x-1 items-center">
              <img src={getValue().logo} className="h-4" />
              <div
                className="truncate font-extrabold"
                dangerouslySetInnerHTML={{ __html: getValue().html }}
              ></div>
            </div>,
          );
        },
        enableSorting: false,
        size: 250,
      },
      {
        id: "createdAt",
        header: "Created At",
        accessorFn: (row) => parseUnixTimestamp(row.document.createdAt),
        cell: function render({ getValue }: any) {
          return makeTooltip(
            getValue().format("DD/MM/YYYY HH:mm"),
            getValue().format("ddd, MMM D, YYYY HH:mm"),
          );
        },
        enableColumnFilter: true,
      },
      {
        // Actions column with edit/delete/show buttons
        id: "actions",
        size: 70,
        header: "Actions",
        cell: ({ row }) => (
          <>
            <ShowButton
              size="sm"
              hideText={true}
              recordItemId={row.original.document.id}
            />
          </>
        ),
        enableSorting: false, // Disable sorting for action buttons
        enableColumnFilter: false, // Disable filtering for action buttons
      },
    ],
    [],
  );
  return columns;
};
